/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kicukiro 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gasharu": ["Amajyambere", "Gasharu", "Sakirwa", "Umunyinya"],
  "Kagina": ["Gashiha", "Iriba", "Multimedia", "Umunyinya", "Umuremure", "Urugero"],
  "Kicukiro": ["Gasave", "Isoko", "Karisimbi", "Kicukiro", "Triangle", "Ubumwe"],
  "Ngoma": ["Ahitegeye", "Intaho", "Iriba", "Isangano", "Urugero"]
};